module.exports = "<div [ngBusy]=\"busyLoading\"></div>\n"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-spinner/cui-spinner.component.html
// module id = ../../../../../src/app/shared/cui-spinner/cui-spinner.component.html
// module chunks = main